<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <EventsList
      :tenantId="tenantId"
      :projectId="projectId"
      :deviceId="deviceId"
      :date="date"
    ></EventsList>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import EventsList from "@/components/events/eventsList.vue";

export default {
  components: {
    Breadcrumb,
    EventsList,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const message = ref("");
    const tenantId = ref(computed(() => store.getters.tenantId));
    const projectId = ref(computed(() => route.params.projectId));
    const deviceId = ref(computed(() => route.params.deviceId));
    const date = computed(() => route.params.date);
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: "Data",
        path: {
          name: "dataList",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: deviceId.value,
        path: {
          name: "dataView",
          params: {
            projectId: route.params.projectId,
            deviceId: route.params.deviceId,
          },
        },
        isActive: true,
      },
    ]);

    return {
      tenantId,
      projectId,
      deviceId,
      date,
      breadcrumb,
      message,
    };
  },
};
</script>
